/* eslint-disable max-len */
import { FC } from 'react';

import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const PaymentMethodVisaIcon: FC<Props> = ({ className }) => (
  <svg data-testid="visa" className={className} viewBox="0 0 59 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.863594"
      y="0.863594"
      width="56.9972"
      height="39.7253"
      rx="6.04516"
      fill="white"
      stroke="#B8C3D1"
      strokeWidth="1.72719"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5416 27.0583H14.9933L12.3325 16.7226C12.2062 16.2471 11.938 15.8268 11.5435 15.6287C10.5591 15.1309 9.47439 14.7347 8.29103 14.5348V14.1369H14.0072C14.7961 14.1369 15.3877 14.7347 15.4864 15.4289L16.8669 22.8844L20.4136 14.1369H23.8633L18.5416 27.0583ZM25.8354 27.0577H22.4843L25.2437 14.1363H28.5948L25.8354 27.0577ZM32.93 17.7155C33.0286 17.0196 33.6203 16.6216 34.3106 16.6216C35.3953 16.5217 36.577 16.7215 37.5631 17.2177L38.1548 14.4356C37.1686 14.0377 36.0839 13.8379 35.0995 13.8379C31.847 13.8379 29.4802 15.6277 29.4802 18.1117C29.4802 20.0014 31.1567 20.9936 32.34 21.5914C33.6203 22.1874 34.1133 22.5854 34.0147 23.1814C34.0147 24.0754 33.0286 24.4733 32.0442 24.4733C30.8608 24.4733 29.6775 24.1753 28.5944 23.6775L28.0028 26.4613C29.1861 26.9574 30.4664 27.1572 31.6497 27.1572C35.2967 27.2554 37.5631 25.4673 37.5631 22.7835C37.5631 19.4037 32.93 19.2056 32.93 17.7155ZM49.2906 27.0577L46.6297 14.1363H43.7717C43.18 14.1363 42.5883 14.5342 42.3911 15.1302L37.4639 27.0577H40.9136L41.6022 25.1697H45.8408L46.2353 27.0577H49.2906ZM44.2657 17.6141L45.2501 22.4839H42.4906L44.2657 17.6141Z"
      fill="#172B85"
    />
  </svg>
);
